import { FieldProps } from "components/form/input";
import { FormFieldsProps } from "../../calculator";
import validator from "validator";

export interface LoginState {
  form: {
    email: FieldProps;
    password: FieldProps;
  };
  formValid: boolean;
  formSubmitted: boolean;
}

export const defaultLoginState: LoginState = {
  form: {
    email: {
      value: "",
      valid: false,
    },
    password: {
      value: "",
      valid: false,
    },
  },
  formValid: false,
  formSubmitted: false,
};

export const formFields: FormFieldsProps<string>[] = [
  {
    fieldName: "email",
    label: "Email",
    col: "12",
    validationRule: (input) => validator.isEmail(String(input)),
  },
  {
    fieldName: "password",
    label: "Password",
    type: "password",
    col: "12",
  },
];
export interface LoginInterface {
  login: {
    email: string;
    password: string | number;
  };
}
